import { PureComponent } from 'react';
import clsx from 'clsx';

const modifierMapping: { [index: string]: string } = {
  default: '',
  wide: 'Fieldset--wide',
};

interface Props {
  children?: React.ReactNode;
  modifierClassName?: string;
  label?: string;
  modifier?: 'default' | 'wide';
}

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
export default class Fieldset extends PureComponent<Props> {
  static defaultProps: Partial<Props> = {
    modifier: 'default',
  };

  render() {
    const { children, label, modifier, modifierClassName, ...rest } = this.props;
    const modifierClass = modifierMapping[modifier as string];
    const className = clsx('Fieldset', modifierClassName, modifierClass);

    return (
      <section className={className} {...rest}>
        {label && <div className="Fieldset-label">{label}</div>}

        {children}
      </section>
    );
  }
}
